import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 px-8" }
const _hoisted_2 = { class: "max-w-lg w-full md:w-80 lg:max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0" }
const _hoisted_8 = { class: "px-8 py-6" }
const _hoisted_9 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_12 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_13 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_15 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_16 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" }
const _hoisted_17 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_18 = { class: "pt-5 text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "mt-2 pb-2 text-left" }
const _hoisted_26 = { class: "mt-2 pb-2 text-left" }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "mt-1" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "mt-1" }
const _hoisted_31 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_32 = { class: "block truncate" }
const _hoisted_33 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_34 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { formatNumber, translate } from "@/utils/tools";
import Toast from "@/components/tools/Toast.vue";
import { DepositPagination } from "./types/deposit.type";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle, Listbox, ListboxButton, ListboxOption, ListboxOptions,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";
import ApproveTopupPaymentSwitchingFilterDialog
  from "@/components/dialogs/ApproveTopupPaymentSwitchingFilterDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveTopupOperator',
  setup(__props) {

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");

const router = useRouter();

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref<DepositPagination[]>([]);
const isLoaded = ref(false);
const approveDialogShow = ref(false)
const processedApproval = ref(false)
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning: false
});
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: [["requested_at", "DESC"]],
});
const filterForm = ref({
  bankAccountNumber: null,
  approve_by: null,
  from: null,
  channel: null,
  to: null,
});
const advanceFilterModal = ref(false);
const approveFromCm = ref({
  id: '',
  operatorId: '',
  transactionDate: '',
  bankName: '',
  bankAccountNumber: '',
  bankAccountOwnerNumber: '',
  amount: '',
  remark: '',
})
const selectedOperatorOption = ref({label: '----select operator----', value: null, id: 0});
// const approveDialogShow = ref(false)
const isCheckTOTP = ref(false);
const isEnabledCmsOtp = ref(false)
const currentAttempts = ref(0);
const totp = ref("");
const isWorking = ref(false);
const isNotified = ref(store.state.user.topupNotification);

const listOperator = ref([])

const columns = ref([
  {
    label: translate("messages.approveTopupV2.transactionDate"),
    field: "transactionDate",
    format: (data: any) => dayjs(data.transactionDate).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approveTopupV2.bankAccount"),
    field: "bankAccount",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => data.bankAccount ? data.bankAccount : "-",
  },
  {
    label: translate("messages.approveTopupV2.paymentName"),
    field: "paymentName",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => (data.paymentName ? data.paymentName : "-"),
  },
  {
    label: translate("messages.approveTopupV2.refCode1"),
    field: "refCode",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => data.refcode ? data.refcode : "-",
  },
  {
    label: translate("messages.approveTopupV2.amount"),
    field: "amount",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => (data.amount ? formatNumber(data.amount) : "-"),
  },
  {
    label: translate("messages.approveTopupV2.status"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => {
      return data.status ? data.status : "-"
    },
    class: (data: any) => {
      let css = 'text-white font-bold text-xs rounded py-1'
      switch (data.status) {
        case 'WAITING_APPROVE':
          css += ' bg-yellow-500'
          break;
        case 'OPEN':
          css += ' bg-blue-500'
          break;
        case 'CALLBACK_SUCCEED':
          css += ' bg-blue-400'
          break;
        case 'SUBMITTED':
          css += ' bg-blue-500'
          break;
        case 'COMPLETED':
          css += ' bg-green-500'
          break;
        case 'REJECTED':
          css += ' bg-red-400'
          break;
        case 'CALLBACK_FAILED':
          css += ' bg-red-300'
          break;
        case 'APPROVING':
          css += ' bg-yellow-300'
          break;
        default:
          css += ' bg-red-500'
          break;
      }
      return css
    },
  },
  {
    label: translate("messages.approveTopupV2.createdAt"),
    field: "createdAt",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approveTopupV2.approve"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      if (data.status === 'WAITING_APPROVE') {
        approveFromCm.value = {
          id: data.id,
          operatorId: ``,
          transactionDate: data.transactionDate,
          bankName: data.bank,
          bankAccountNumber: data.bankAccount,
          bankAccountOwnerNumber: data.bankOwnerAccount,
          amount: formatNumber(data.amount),
          remark: data.remark
        }
        approveDialogShow.value = true
      }
      return
    },
    class: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
      return 'block'
    },
    format: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return translate("messages.approveTopupV2.approve")
      return ''
    },
    permission: 'PAYMENT_CONFIG.DEPOSIT.APPROVE'
  },
]);


const onApprove = async () => {
  if(processedApproval.value){
    return
  }
  processedApproval.value = true
  try {
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank-deposit-pending/approve/operator`;
    const payload = {
      operatorId: selectedOperatorOption.value.value,
      id: approveFromCm.value.id,
    }
    const data = await axios
        .post(url, payload)
        .then(({ data }) => data);
    if (!data) return alert("fail approve")
    alert('success')
    approveDialogShow.value = false
    selectedOperatorOption.value = {label: '----select operator----', value: null, id: 0}
    await fetchPageData()
  } catch (e) {
    alert('Failed')
  }
  processedApproval.value = false
}

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};


const fetchPageData = async () => {
  const { page, rowsPerPage } = pageConfig.value;
  const { approve_by, from, to, channel, bankAccountNumber } = filterForm.value;

  const payload: any = {
    page: page,
    pageSize: rowsPerPage,
    operatorId: null,
    bankAccountNumber: bankAccountNumber ? bankAccountNumber : undefined,
    status: ["WAITING_APPROVE", "OPEN"],
    approve_by: approve_by || undefined,
    channel: channel || undefined,
    startDate: dayjs(from) || null,
    endDate: dayjs(to) || null,
    sort: [['transactionDate','DESC']],
  };
  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank-deposit-pending/pagination`;
  const { result: data } = await axios
      .post(url, payload)
      .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
      {},
      document.title,
      `?${stringify({ page, rowsPerPage })}`
  );
  isEnabledCmsOtp.value = store.state.selectedOperator.bypassPaymentApprovalTotp
  isCheckTOTP.value = false
  totp.value = ''
  isLoaded.value = true;
};

const getAllOperator = async () => {
  const operator = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/list-pagination`,
      {
        filters: null,
        showDeleted: false,
        pageSize: 999,
        page: 0,
        sortBy: [['updatedAt', -1]],
      })
  listOperator.value = operator.data.result.rows.map((op, index)=> ({label: op.name, value: op.id, index}))
}

// const updateNotification = () => {
//   const notification = isNotified.value ? false : true;
//   isNotified.value = notification;
//   store.commit("serUserTopupNotification", notification);
// };

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
  getAllOperator();
});

/** fetch data when current page was changed */
watch(
    () => pageConfig.value.page,
    () => fetchPageData()
);


/** fetch data when rows per page was changed */
watch(
    () => pageConfig.value.rowsPerPage,
    () => {
      pageConfig.value.page = 1;
      fetchPageData();
    }
)

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.approveTopupV2.assignOperatorTopup')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(SearchIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterForm.value.bankAccountNumber) = $event)),
            class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
            placeholder: _ctx.$t('messages.depositPaymentSwitching.searchBankAccountNumber'),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData())),
            type: "search",
            name: "search"
          }, null, 40, _hoisted_6), [
            [_vModelText, filterForm.value.bankAccountNumber]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DateSelector, { onSearch: onSearch })
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: _ctx.doSort
          }, null, 8, ["columns", "data", "onSort"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ], 512), [
      [_vShow, isLoaded.value]
    ]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: approveDialogShow.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_14,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-green-600",
                          icon: ['far', 'check'],
                          transform: "grow-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.approveTopupV2.approveTopupTitle")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankName || "-"), 1),
                          _hoisted_19,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountNumber ||
                "-"), 1),
                          _hoisted_20,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountOwnerNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountNumber ||
                "-"), 1),
                          _hoisted_21,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.remark")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.remark ||
                "-"), 1),
                          _hoisted_22,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.amount")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.amount || "-"), 1),
                          _hoisted_23,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.transactionDate")), 1),
                          _createTextVNode(": " + _toDisplayString(_unref(dayjs)(approveFromCm.value.transactionDate).locale("th").format("LLL") || "-"), 1),
                          _hoisted_24
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("messages.approveTopupV2.operator")), 1),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_unref(Listbox), {
                                  modelValue: selectedOperatorOption.value,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedOperatorOption).value = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_31, [
                                            _createElementVNode("span", _hoisted_32, _toDisplayString(selectedOperatorOption.value.label), 1),
                                            _createVNode(_component_SelectorIcon, {
                                              class: "w-5 h-5 text-gray-400 ml-auto",
                                              "aria-hidden": "true"
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_Transition, {
                                        "leave-active-class": "transition duration-100 ease-in",
                                        "leave-from-class": "opacity-100",
                                        "leave-to-class": "opacity-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listOperator.value, (option, index) => {
                                                return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                                  key: index,
                                                  value: option,
                                                  as: "template"
                                                }, {
                                                  default: _withCtx(({ active, selected }) => [
                                                    _createElementVNode("li", {
                                                      class: _normalizeClass([
                                    active
                                      ? 'text-amber-900 bg-amber-100'
                                      : 'text-gray-900',
                                    'cursor-default select-none relative py-2 pl-10 pr-4',
                                  ])
                                                    }, [
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass([
                                      selected ? 'font-medium' : 'font-normal',
                                      'block truncate',
                                    ])
                                                      }, _toDisplayString(option.label), 3),
                                                      selected
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                            _createVNode(_unref(CheckIcon), {
                                                              class: "w-5 h-5",
                                                              "aria-hidden": "true"
                                                            })
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ], 2)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("button", {
                        class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                        onClick: onApprove
                      }, " Approve "),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = () => { approveDialogShow.value = false }),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})